import FlowGlobalEdge from '../components/edges/FlowGlobalEdge';
import LoopEdge from '../components/edges/LoopEdge';
import SelectableDefaultEdge from '../components/edges/SelectableDefaultEdge';
import FileSave from '../components/FileSave/FileSave';
import ImageComponent from '../components/FormNodes/ImageComponent/ImageComponent';
import InputNodeDisplay from '../components/FormNodes/InputNodeDisplay/InputNodeDisplay';
import LinesNode from '../components/FormNodes/LinesNode';
import List from '../components/FormNodes/ListNode/List';
import OutputNodeDisplay from '../components/FormNodes/OutputNodeDisplay/OutputNodeDisplay';
import ShortText from '../components/FormNodes/ShortText/ShortText';
import SubmitButtonNode from '../components/FormNodes/SubmitButtonNode/SubmitButtonNode';
import TitleNode from '../components/FormNodes/TitleNode/TitleNode';
import PullHubSpotData from '../components/HubSpotDataNode/PullHubSpotDataNode';
import AiAudioGenerator from '../components/nodes/AiAudioGenerator';
import AiAudioTranscriber from '../components/nodes/AiAudioTranscriber';
import AiMusicGenerator from '../components/nodes/AiMusicGenerator';
import AiTextGenerator from '../components/nodes/AiTextGenerator';
import AiTextSummarizer from '../components/nodes/AiTextSummarizer';
import AiVideoGenerator from '../components/nodes/AiVideoGenerator';
import ApiCaller from '../components/nodes/ApiCaller';
import ApiInput from '../components/nodes/ApiInput';
import ApiOutput from '../components/nodes/ApiOutput';
import DecisionPaths from '../components/nodes/DecisionPaths';
import DynamicSettingNode from '../components/nodes/DynamicSettingNode';
import FlowCaller from '../components/nodes/FlowCaller';
import FlowCreator from '../components/nodes/FlowCreator';
import FlowDataCaller from '../components/nodes/FlowDataCaller';
import FlowGlobalNode from '../components/nodes/FlowGlobalNode';
import ImageGenerator from '../components/nodes/ImageGenerator';
import ImageReader from '../components/nodes/ImageReader';
import LargeMemory from '../components/nodes/LargeMemory';
import LibraryNode from '../components/nodes/LibraryNode';
import MathFunction from '../components/nodes/MathFunction';
import MediaBox from '../components/nodes/MediaBox';
import NodesGroup from '../components/nodes/NodesGroup';
import ObjectCaller from '../components/nodes/ObjectCaller';
import OutputControllerNode from '../components/nodes/OutputControllerNode';
import ProcessCounter from '../components/nodes/ProcessCounter';
import ReportBuilderNode from '../components/nodes/ReportBuilderNode';
import RichTextBoxNode from '../components/nodes/RichTextBoxNode';
import Scripting from '../components/nodes/Scripting';
import SecApiNode from '../components/nodes/SecApiNode';
import SequenceNode from '../components/nodes/SequenceNode';
import SmallMemory from '../components/nodes/SmallMemory';
import SqlQuerier from '../components/nodes/SqlQuerier';
import StickyNote from '../components/nodes/StickyNote';
import StoredDataCaller from '../components/nodes/StoredDataCaller';
import TableOutput from '../components/nodes/TableOutput';
import TableProcessor from '../components/nodes/TableProcessor';
import TextBoxNode from '../components/nodes/TextBoxNode';
import UsCensusNode from '../components/nodes/UsCensusNode';
import WebAmazon from '../components/nodes/WebAmazon';
import WebCrawling from '../components/nodes/WebCrawling';
import WebSearch from '../components/nodes/WebSearch';
import WebTrends from '../components/nodes/WebTrends';
import PullData from '../components/PullDataNode/PullDataNode';
import PushData from '../components/PushDataNode/PushDataNode';

export const nodeTypes = {
  globalStarter: FlowGlobalNode,
  commandTextNode: AiTextGenerator,
  outputController: OutputControllerNode,
  reportBuilder: ReportBuilderNode,
  fluxObject: SmallMemory,
  varInputNode: ApiInput,
  outputObjectNode: ApiOutput,
  conditionNode: DecisionPaths,
  textBox: TextBoxNode,
  richTextBox: RichTextBoxNode,
  voiceBoxNode: AiAudioGenerator,
  commandContentNode: LargeMemory,
  nodesBox: ObjectCaller,
  fluxBox: FlowCaller,
  storedDataCaller: StoredDataCaller,
  imageGenerator: ImageGenerator,
  nodesGroup: NodesGroup,
  arrayNode: SequenceNode,
  webSearch: WebSearch,
  // webMedia: WebMedia,
  // webLocations: WebLocations,
  // webNews: WebNews,
  deepRefNode: FlowDataCaller,
  mathFunction: MathFunction,
  scripting: Scripting,
  counterNode: ProcessCounter,
  tableProcessor: TableProcessor,
  outputTable: TableOutput,
  dynamicSettingsNode: DynamicSettingNode,
  audioReaderNode: AiAudioTranscriber,
  commandMusicNode: AiMusicGenerator,
  apiCaller: ApiCaller,
  sqlQuerier: SqlQuerier,
  imageReaderNode: ImageReader,
  webCrawling: WebCrawling,
  webTrends: WebTrends,
  animationNode: AiVideoGenerator,
  usCensusNode: UsCensusNode,
  documentSummarizer: AiTextSummarizer,
  secApiNode: SecApiNode,
  webAmazon: WebAmazon,
  stickyNote: StickyNote,
  pullData: PullData,
  pushData: PushData,
  fileSave: FileSave,
  nodesAdd: FlowCreator,
  hubSpotCRM: PullHubSpotData,
  mediaBox: MediaBox,
  libraryNode: LibraryNode,
};

export const edgeTypes = {
  custom: FlowGlobalEdge,
  loopEdge: LoopEdge,
  default: SelectableDefaultEdge,
};

export const formNodeTypes = {
  title: TitleNode,
  shortText: ShortText,
  listNode: List,
  image: ImageComponent,
  submit: SubmitButtonNode,
  inputDisplay: InputNodeDisplay,
  outputDisplay: OutputNodeDisplay,
  linesNode: LinesNode,
};
